
import { SetupContext } from 'vue'

export default {
  name: 'searchKeyword',

  props: {
    value: {
      type: String,
      default: ''
    }
  },

  setup(props: any, context: SetupContext) {
    const updateValue = (e: any) => {
      context.emit('call-input-change', e.target.value)
    }

    const submitSearchKeyword = (ev: any) => {
      ev.preventDefault()

      context.emit('submit-keyword')
    }

    return {
      updateValue,
      submitSearchKeyword
    }
  }
}
